import { render, staticRenderFns } from "./DiagnosticService.vue?vue&type=template&id=370dd233&"
import script from "./DiagnosticService.vue?vue&type=script&lang=js&"
export * from "./DiagnosticService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports